import { render } from "./MovePage.vue?vue&type=template&id=a9a180d4&scoped=true"
import script from "./MovePage.vue?vue&type=script&lang=js"
export * from "./MovePage.vue?vue&type=script&lang=js"

import "./MovePage.vue?vue&type=style&index=0&id=a9a180d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a180d4"]])

export default __exports__